import {
  ExternalTokenActionTypes,
  ICreateOrUpdateExternalTokenPayload,
  ICreateOrUpdateExternalTokenSuccessResponseBody,
  IDeleteExternalTokenPayload,
  IFetchExternalTokensPayload,
  IFetchExternalTokensSuccessResponseBody,
} from './types'

export const fetchExternalTokens = (payload: IFetchExternalTokensPayload) => ({
  type: ExternalTokenActionTypes.FETCH_EXTERNAL_TOKENS,
  payload,
})

export const fetchExternalTokensSuccess = (payload: IFetchExternalTokensSuccessResponseBody) => ({
  type: ExternalTokenActionTypes.FETCH_EXTERNAL_TOKENS_SUCCESS,
  payload,
})

export const fetchExternalTokensFailure = () => ({
  type: ExternalTokenActionTypes.FETCH_EXTERNAL_TOKENS_FAILURE,
})

export const createOrUpdateExternalToken = (payload: ICreateOrUpdateExternalTokenPayload) => ({
  type: ExternalTokenActionTypes.CREATE_OR_UPDATE_EXTERNAL_TOKEN,
  payload,
})

export const createOrUpdateExternalTokenSuccess = (payload: ICreateOrUpdateExternalTokenSuccessResponseBody) => ({
  type: ExternalTokenActionTypes.CREATE_OR_UPDATE_EXTERNAL_TOKEN_SUCCESS,
  payload,
})

export const createOrUpdateExternalTokenFailure = () => ({
  type: ExternalTokenActionTypes.CREATE_OR_UPDATE_EXTERNAL_TOKEN_FAILURE,
})

export const deleteExternalToken = (payload: IDeleteExternalTokenPayload) => ({
  type: ExternalTokenActionTypes.DELETE_EXTERNAL_TOKEN,
  payload,
})

export const deleteExternalTokenSuccess = (payload: IDeleteExternalTokenPayload) => ({
  type: ExternalTokenActionTypes.DELETE_EXTERNAL_TOKEN_SUCCESS,
  payload,
})

export const deleteExternalTokenFailure = () => ({
  type: ExternalTokenActionTypes.DELETE_EXTERNAL_TOKEN_FAILURE,
})
